export default "/images/kyc_and_verifications__icon.png";